/* esm.sh - zod@4.4.3 */
import*as o from"zod/v4/classic/external";export*from"zod/v4/classic/external";var r=o;export{r as default,o as z};
//# sourceMappingURL=zod.mjs.map